module.exports = __webpack_public_path__ + "9a31c53dff41c01afb993dde5d4377c4.png";